// Home v2 — animated banner surface for the balance card / dashboard overview.
// Wraps the vendored Grainient WebGL gradient and swaps its 3 colors by wallet
// mode (public = blue / private = orange). Web-only (DOM <div> + WebGL): named
// `.web.tsx` so Metro resolves the trivial `.tsx` fallback on native.
import React from 'react'

import { Mode } from '@web/contexts/appModeContext'

import Grainient from './Grainient/Grainient'
import { GRAINIENT_BASE, GRAINIENT_COLORS } from './tokens'

type Props = {
  mode: Mode
  borderRadius?: number
}

const GrainientBanner: React.FC<Props> = ({ mode, borderRadius = 16 }) => (
  <div
    style={{
      position: 'absolute',
      inset: 0,
      borderRadius,
      overflow: 'hidden',
      pointerEvents: 'none'
    }}
  >
    <Grainient {...GRAINIENT_BASE} {...GRAINIENT_COLORS[mode]} />
  </div>
)

export default React.memo(GrainientBanner)
